export default "__VITE_ASSET__t14TMwE5__"